import React from 'react';
import { Layout } from 'antd';

import Content from '../../../components/Pages/QcReports/Create';
import { displayName } from '../../../config';
import QcReportsCreateProvider from '../../../context/qcReportCreate';

const QcReportCreate: React.FC = (): JSX.Element => {
  document.title = `${displayName}: QC Report Create`;

  return (
    <Layout>
      <QcReportsCreateProvider>
        <Content />
      </QcReportsCreateProvider>
    </Layout>
  );
};

export default QcReportCreate;
